angular.module('iw.frontyard.repayment_calculator')
    .directive('iwRepaymentCalculator', function (FRONTYARD_ROOT_URL,
                                                  calculateTablePadding,
                                                  RepaymentScheduler,
                                                  $window,
                                                  $locale) {
        return {
            restrict: 'E',
            scope: {
                amountSlider: '=',
                durationSlider: '=',
                rateSlider: '=',
                minimumAmount: '=',
                maximumAmount: '=',
                initialAmount: '=',
                minimumDuration: '=',
                maximumDuration: '=',
                initialDuration: '=',
                minimumRate: '=',
                maximumRate: '=',
                initialRate: '=',
                currencySymbol: '@',
            },
            transclude: true,
            templateUrl: FRONTYARD_ROOT_URL + 'frontyard/repayment_calculator/directives/iwRepaymentCalculator.html',
            compile: function () {
                return {
                    pre: function ($scope, ngModel) {
                        var loan = {
                            amount: Math.pow($scope.initialAmount, 1 / 2),
                            duration: $scope.initialDuration,
                            rate: $scope.initialRate,
                            annualPercentageRate: $window.ANNUAL_PERCENTAGE_RATE,
                        };
                        $scope.loan = loan;
                        let increment = 500;
                        var scheduler = new RepaymentScheduler($window.SITE_CODE, $window.SIMPLE_RATES, $window.DEFAULT_FEE_RATE);
                        scheduler.calculateSchedule(loan.amount, loan.duration, loan.rate);
                        $scope.scheduler = scheduler;
                        $scope.currencyDigits = scheduler.currencyDigits;

                        $scope.amountConfig = {
                            min: Math.pow($scope.minimumAmount, 1 / 2),
                            max: Math.pow($scope.maximumAmount, 1 / 2),
                            value: Math.pow($scope.initialAmount, 1 / 2),
                            step: 0.1,
                            range: 'min',
                            slide: function (event, ui) {
                                var amount = Math.round(ui.value * ui.value / increment) * increment;
                                scheduler.calculateSchedule(amount, loan.duration, loan.rate);
                                $scope.$applyAsync();
                            },
                            change: function (event, ui) {
                                var amount = Math.round(ui.value * ui.value / increment) * increment;
                                scheduler.calculateSchedule(amount, loan.duration, loan.rate);
                                $scope.$applyAsync();
                            }
                        };

                        $scope.durationConfig = {
                            min: $scope.minimumDuration,
                            max: $scope.maximumDuration,
                            value: $scope.initialDuration,
                            range: 'min',
                            slide: function (event, ui) {
                                scheduler.calculateSchedule($scope.scheduler.totalAmount, ui.value, loan.rate);
                                $scope.smallPadding = calculateTablePadding(ui.value);
                                $scope.$applyAsync();
                            },
                            change: function (event, ui) {
                                scheduler.calculateSchedule($scope.scheduler.totalAmount, ui.value, loan.rate);
                                $scope.smallPadding = calculateTablePadding(ui.value);
                                $scope.$applyAsync();
                            }
                        };

                        if ($scope.rateSlider) {
                            $scope.rateConfig = {
                                min: $scope.minimumRate,
                                max: $scope.maximumRate,
                                value: $scope.initialRate,
                                range: 'min',
                                step: 0.1,
                                slide: function (event, ui) {
                                    scheduler.calculateSchedule($scope.scheduler.totalAmount, loan.duration, ui.value);
                                    $scope.smallPadding = calculateTablePadding(ui.value);
                                    $scope.$applyAsync();
                                },
                                change: function (event, ui) {
                                    scheduler.calculateSchedule($scope.scheduler.totalAmount, loan.duration, ui.value);
                                    $scope.smallPadding = calculateTablePadding(ui.value);
                                    $scope.$applyAsync();
                                }
                            };
                        }


                    },
                    post: function () {
                    }
                };
            }
        };
    });
